import * as S from './Style'

import { useEffect, useState } from 'react'

import { t } from 'i18next'
import { useDispatch, useSelector } from 'react-redux'
import { EventSourcePolyfill } from 'event-source-polyfill'
import { update, dataInitalState } from '@/core/store/data/actions'
import { clearUser } from '@/core/store/user/actions'
import { formatMoney, getBaseCurrency } from '@/constant/currency'

import logoGold from '@/assets/image/logo_gold.png'
import accountIcon from '@/assets/image/gold/account_icon.png'
import iconsSprite from '@/assets/icons.svg'
import Login from '@/components/popup/Login'
import { useCommonState } from '@/core/context/useContext'
import { useConfirm, usePopup } from '@/core/context/useWindow'
import useLogout from '@/core/hooks/useLogout'
import useToast from '@/core/hooks/useToast'
import useRefreshMoney from '@/core/hooks/useRefreshMoney'

export default function GrandHeader() {
  const { isLogin } = useCommonState();
  const loggedIn = isLogin;

  const infoData = useSelector((state) => state.Data);
  const { openPopup } = usePopup();
  const { openConfirm } = useConfirm();
  const { logout } = useLogout();

  const dispatch = useDispatch();
  const [reconnectCount, setReconnectCount] = useState(0);
  const MAX_RECONNECT_ATTEMPTS = 5;
  const { Toast, openToast } = useToast();
  const [toastMsg, setToastMsg] = useState('');

  const authUser = useSelector((s) => s.User) || {};
  // 새로고침 아이콘 — 페이지를 다시 불러오지 않고 아이콘을 돌리며 머니만 갱신
  const { spinning: moneySpinning, refresh: refreshMoney } = useRefreshMoney();

  /**
   * SSE header-alarm 연결
   */
  useEffect(() => {
    if (!authUser?.id) return

    try {
      const sse = new EventSourcePolyfill(
        `${process.env.REACT_APP_BASE_URL}/v1/SSE/header-alarm`,
        { withCredentials: true, heartbeatTimeout: 45000 }
      )

      sse.addEventListener('update', (e) => {
        setReconnectCount(0)
        if (e?.data) {
          try {
            const userData = JSON.parse(e.data)
            if (userData?.bet_type === 'win') {
              const timer = userData.game_type === 'slot' ? 500 : 3200
              setTimeout(() => { dispatch(update(userData)) }, timer)
            } else {
              dispatch(update(userData))
            }
          } catch (error) {
            console.error('SSE Header Alarm update 이벤트 파싱 오류:', error)
          }
        }
      })

      sse.addEventListener('userLogout', (e) => {
        if (e?.data) {
          try {
            dispatch(dataInitalState())
            dispatch(clearUser())
            window.location.href = '/'
          } catch (error) {
            console.error('SSE Header Alarm userLogout 이벤트 파싱 오류:', error)
          }
        }
      })

      // 베팅 한도(최소/최대) 초과 거절 알림
      sse.addEventListener('betReject', (e) => {
        if (e?.data) {
          try {
            const { kind } = JSON.parse(e.data)
            setToastMsg(t('bet_reject.' + kind))
            openToast()
          } catch (error) {
            console.error('SSE Header Alarm betReject 이벤트 파싱 오류:', error)
          }
        }
      })

      sse.onerror = () => {
        console.error('SSE Header Alarm 연결 오류')
        sse.close()
        if (reconnectCount < MAX_RECONNECT_ATTEMPTS) {
          setTimeout(() => setReconnectCount(prev => prev + 1), 3000)
        } else {
          console.error('SSE Header Alarm 재연결 최대 시도 횟수 초과')
        }
      }

      return () => {
        sse.close()
      }
    } catch (error) {
      console.error('Error Header Alarm SSE:', error)
    }
  }, [authUser?.id, reconnectCount, dispatch])
  const userId = authUser?.id || "";

  const openLoginPopup = (e) => {
    e.preventDefault();
    openPopup({
      grandLogin: true,
      title: t("modalTitle.login"),
      content: <Login />,
    });
  };

  const handleLogout = () => {
    openConfirm({
      message: t("alert.islogout"),
      Func: () => { logout(); },
    });
  };

  return (
    <S.GoldHeader>
      <Toast toastText={toastMsg} />
      <S.GoldHeaderInner>
        <S.GoldLogo href="/">
          <S.GoldLogoImg
            src={logoGold}
            alt=""
          />
        </S.GoldLogo>
        <S.GoldAccount>
          {loggedIn ? (
            <>
              <S.GoldInfo>
                <S.GoldInfoItem>
                  {t('gold.account')} :<S.GoldInfoValue>{userId}</S.GoldInfoValue>
                  <S.GoldAccountIcon src={accountIcon} alt="" />
                </S.GoldInfoItem>
                <S.GoldInfoItem>
                  {t('gold.balance')} :<S.GoldInfoValue>{getBaseCurrency()} {formatMoney(infoData?.money ?? 0)}</S.GoldInfoValue>
                  <S.GoldSync type="button" aria-label="refresh" aria-busy={moneySpinning} $spinning={moneySpinning} onClick={refreshMoney}>
                    <svg viewBox="0 0 16 16" aria-hidden="true"><use href={`${iconsSprite}#ico-reset`} /></svg>
                  </S.GoldSync>
                </S.GoldInfoItem>
              </S.GoldInfo>
              <S.GoldSignout type="button" onClick={handleLogout}>
                <svg viewBox="0 0 22 22" aria-hidden="true"><use href={`${iconsSprite}#ico-logout`} /></svg>
                LOGOUT
              </S.GoldSignout>
            </>
          ) : (
            <S.GoldLoginBtn type="button" onClick={openLoginPopup}>{t('header.login')}</S.GoldLoginBtn>
          )}
        </S.GoldAccount>
      </S.GoldHeaderInner>
    </S.GoldHeader>
  );
}
